import classNames from 'classnames';
import React, { FC } from 'react';
import { CheckmarkRegularIcon } from 'src/monet/icons';
import { Nullable } from 'src/types/nullable.type';
import { functionNoop } from 'src/utils/function/noop';

interface ManagementDropdownListProps {
  selectedValue: Nullable<any>;
  items: any[];
  defaultItem?: any;
  onSelectedItemChanged: (id: any) => void;
  itemClassNameIterator?: (item: any) => string;
}

interface ManagementDropdownListItemProps {
  item: any;
  selectedValue: any;
  onClick: (id: any) => void;
  className?: string;
}

const ManagementDropdownList: FC<ManagementDropdownListProps> = ({
  selectedValue,
  items,
  defaultItem,
  onSelectedItemChanged,
  itemClassNameIterator = functionNoop,
}) => {
  return (
    <div className='space-y-2 max-h-[540px] overflow-y-auto'>
      {defaultItem && (
        <ManagementDropdownListItem onClick={onSelectedItemChanged} item={defaultItem} selectedValue={selectedValue} />
      )}
      {items.map((item: any) => {
        if (!item) return null;

        return (
          <ManagementDropdownListItem
            key={item.id}
            className={itemClassNameIterator(item)}
            onClick={onSelectedItemChanged}
            item={item}
            selectedValue={selectedValue}
          />
        );
      })}
    </div>
  );
};

const ManagementDropdownListItem: FC<ManagementDropdownListItemProps> = ({
  item,
  selectedValue,
  onClick,
  className,
}) => {
  const selected = item.id === selectedValue;
  const onClickHandler = () => {
    onClick(item.id);
  };

  return (
    <div
      onClick={onClickHandler}
      className={classNames('flex flex-row space-x-2 hover:opacity-80 w-full cursor-pointer', className)}
    >
      <div className='h-5 w-5'>{selected && <CheckmarkRegularIcon />}</div>
      <span className='text-bedrock-p text-bedrock-black'>{item.name}</span>
    </div>
  );
};

export default ManagementDropdownList;
